import type { Components, Theme } from "@mui/material";

export const MuiAlert: Components<Theme>["MuiAlert"] = {
	defaultProps: {
		variant: "outlined",
	},
	variants: [
		{
			props: {},
			style: ({ theme }) => ({
				".MuiAlert-message": {
					display: "flex",
					flexDirection: "column",
					gap: theme.spacing(0.5),
					width: "100%",
				},
			}),
		},

		{
			props: { variant: "outlined" },
			style: ({ theme }) => ({
				borderRadius: theme.spacing(2),
			}),
		},
		{
			props: { severity: "success" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.success.background,
			}),
		},
		{
			props: { severity: "info" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.info.background,
			}),
		},
		{
			props: { severity: "warning" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.warning.background,
			}),
		},
		{
			props: { severity: "error" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.error.background,
			}),
		},
	],
};
